import { render, staticRenderFns } from "./ServiceDiscovery.vue?vue&type=template&id=d45fe850&scoped=true"
import script from "./ServiceDiscovery.vue?vue&type=script&lang=js"
export * from "./ServiceDiscovery.vue?vue&type=script&lang=js"
import style0 from "./ServiceDiscovery.vue?vue&type=style&index=0&id=d45fe850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45fe850",
  null
  
)

export default component.exports